import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"


const AdjustSMSForm = () => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false);
    const [branchOptions, setBranchOptions] = useState([]);

    const [formData, setFormData] = useState({
        branch_id: "",
        debit: 0,
        credit: 0,
        date: new Date().toISOString().slice(0, 10),
        remark: ""
    })
    const {branch_id, debit, credit, date, remark} = formData

    const navigate = useNavigate()


    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {branch_id, debit, credit, date, remark}
        if (parseInt(debit) === 0 && parseInt(credit) === 0) return null;
        adjustMessageBalance(payload)
    }

    const loadOptions = async (url, query, setOptions) => {
        try {
            const response = await Server.get(`/options/${url}`, {
                params: { q: query },
            });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };
    
    const adjustMessageBalance = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/messages/adjust', payload)
            setIsLoading(false);
            if (response.status === 201){
                toast.success('Successfully adjusted')
                navigate('/sms-balance')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Adjust SMS Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <AsyncSelectField
                                name="branch_id"
                                label="Company"
                                value={branch_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('branches', query, setBranchOptions)}
                                options={branchOptions}
                                placeholder="Start typing to search..."
                                error={errors.branch_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Debit Amount"
                                name="debit"
                                type="number"
                                label="Debit"
                                value={debit}
                                onChange={onChange}
                                error={errors.debit}
                                style={{height: '100px'}}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                name="credit"
                                type="number"
                                label="Credit"
                                value={credit}
                                onChange={onChange}
                                error={errors.credit}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                name="date"
                                type="date"
                                label="date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                        <div className="col-md-8">
                            <InputField
                                placeholder="Remark(Optional)"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Adjust Balance" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default AdjustSMSForm
